import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { catchError, debounceTime, map, of } from 'rxjs';
import { ValidateReferralGQL } from '../../_graphql/generated';

export function uniqueReferralValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options: any,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) return of(null);
  return (options.query as ValidateReferralGQL)
    .fetch(
      {
        referral: control.value,
      },
      {
        context: {
          headers: { 'x-hasura-role': 'anonymous' },
        },
      },
    )
    .pipe(
      debounceTime(100),
      map((r) => {
        const isUnique = (r?.data?.cer?.length ?? 0) == 0;
        return isUnique ? null : { uniqueReferral: true };
      }),
      catchError(() => {
        return of({ uniqueReferral: true });
      }),
    );
}
